<template>
  <!-- Lekkinud paroolid: this person's password is in the public leak lists
       (server service/pwned.js, checked at their password login). Asked once
       per browser session; "Hiljem" or any other close waits for the next
       session. It stops when the password is changed on Minu seaded. -->
  <v-dialog :model-value="visible" max-width="480" @update:model-value="open => open || later()">
    <div class="dlg" role="alertdialog" aria-labelledby="pwned-title">
      <div class="dlg-cf">
        <span class="dlg-cf-ic" aria-hidden="true">
          <v-icon size="20">mdi-shield-alert-outline</v-icon>
        </span>
        <div>
          <h3 id="pwned-title">Sinu parool on lekkinud</h3>
          <div class="dlg-cf-text">
            See parool esineb avalikes lekkinud paroolide nimekirjades ({{ timesText }}).
            Keegi pole sinu kontole sisse loginud, aga ründajad proovivad just neid paroole. Vaheta parool.
          </div>
          <div v-if="features.passkeyUser" class="dlg-cf-text">
            Veel parem: lisa pääsuvõti ja logi sisse sõrmejälje või näoga.
          </div>
        </div>
      </div>
      <div class="dlg-cf-foot">
        <button type="button" class="dlg-btn dlg-btn--ghost" @click="later">Hiljem</button>
        <button v-if="features.passkeyUser" type="button" class="dlg-btn dlg-btn--ghost" @click="go('paasuvotmed')">Lisa pääsuvõti</button>
        <button type="button" class="dlg-btn" @click="go('parool')">Vaheta parool</button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import '@/styles/dialog-plate.css'

// Per browser tab session and per user, so another person logging in on the
// same computer is still asked.
const key = userId => 'pwned.later.' + userId

export default {
  data: () => ({ dismissed: false }),
  computed: {
    ...mapState(['passwordPwned', 'user', 'features']),
    userId () {
      return this.user && this.user.userId
    },
    visible () {
      return this.passwordPwned > 0 && !this.dismissed && this.$route.name !== 'me'
    },
    timesText () {
      const n = this.passwordPwned
      return n === 1 ? '1 kord' : n.toLocaleString('et-EE') + ' korda'
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler (id) {
        try {
          this.dismissed = !!id && sessionStorage.getItem(key(id)) === '1'
        } catch (err) {
          this.dismissed = false
        }
      }
    }
  },
  methods: {
    later () {
      this.dismissed = true
      try {
        sessionStorage.setItem(key(this.userId), '1')
      } catch (err) {}
    },
    go (row) {
      this.later()
      this.$router.push({ path: '/me', hash: '#' + row })
    }
  }
}
</script>
